export default "__VITE_ASSET__zd5fAJwP__"